import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    objectId: null, 
    objectName: ''
  },
  mutations: {
    SET_OBJECT_ID(state, id) {
      state.objectId = id;
    },
    SET_OBJECT_NAME(state, name) {
      state.objectName = name;
    }
  },

  actions: {
    // Aktionen für Ihren anderen Store
  },
  getters: {
    // Getter für Ihren anderen Store
  }
});